/*eslint-disable */

import FlipCountdown from 'vue2-flip-countdown'
import {bus} from '@/main';

export default {
  name: 'blurb-for-conference-popup',
  components: {
    FlipCountdown
  },
  props: [],
  data () {
    return {
      cdInfoPopupState:false
    }
  },
  computed: {

  },
  mounted () {
  },
  methods: {
    blurbTextPopupClosed(){
      bus.$emit('blurTextbPopupStateBus', false);
      document.body.classList.remove('body_right_scroll_remove')
    },
    cdInfoPopupMethod(){
      this.cdInfoPopupState = true
    },
    cdInfoPopupClosedMethod(){
      this.cdInfoPopupState = false
    }
  }
}